import React from "react";
import AddCompanyForm from "../../../forms/addcompanyform";

const AddCompanyMidComp=()=>{
    return(
        <AddCompanyForm></AddCompanyForm>
    )
}

export default AddCompanyMidComp;